'use client';

import { useEffect } from 'react';

import { api } from '@/lib/api';
import { handleExpiredSession } from '@/lib/session-expired';

/** Страховка: любой cleared/unauthorized из api → единый редирект на login. */
export function AuthSessionGuard() {
  useEffect(() => {
    return api.subscribeAuthEvents((event) => {
      if (event.type === 'cleared' && event.reason === 'unauthorized') {
        handleExpiredSession();
      }
    });
  }, []);

  return null;
}
